import {
    GameEvent,
    isPlayerAction,
    Projection,
    SharedGameState,
    useGameStore,
} from '@glark-newco/game-library';
import dayjs, {Dayjs} from 'dayjs';
import {isCrunchTimePayload, isStartTimerPayload, StartTimerEvent} from '../SignlinesPayloadTypes';

export interface TimestampsSlice extends SharedGameState {
    planningDurationMS?: number;
    planningEndTime?: Dayjs;
    crunchTimeStartTime?: Dayjs;
}

export const timestampsProjection: Projection<TimestampsSlice> = {
    name: 'timestampsProjection',
    project: (
        state: TimestampsSlice,
        newEvents: GameEvent[],
    ): Partial<TimestampsSlice> => {
        const startTimerAction = newEvents
            .filter(isPlayerAction)
            .findLast(ev => isStartTimerPayload(ev.payload));
        const startTimerPayload = startTimerAction?.payload as StartTimerEvent;

        const planningPart = startTimerAction
            ? {
                planningDurationMS: startTimerPayload.duration * 60 * 1000,
                planningEndTime: dayjs(startTimerAction.timestamp).add(startTimerPayload.duration, 'minutes'),
            }
            : {};

        const firstCrunch = newEvents
            .filter(isPlayerAction)
            .find(e => isCrunchTimePayload(e.payload))
            ?.timestamp;

        const crunchPart = (!state.crunchTimeStartTime && firstCrunch)
            ? {crunchTimeStartTime: dayjs(firstCrunch)}
            : {};

        return {...planningPart, ...crunchPart};
    },
    reset: () => ({
        planningDurationMS: undefined,
        planningEndTime: undefined,
        crunchTimeStartTime: undefined,
    }),
};

export const usePlanningEnd = () => {
    const planningDurationMS =  useGameStore((s:TimestampsSlice) => s.planningDurationMS);
    const planningEndTime =  useGameStore((s:TimestampsSlice) => s.planningEndTime);
    return {
        planningDurationMS,
        planningEndTime,
    };
};

export const useIsGameStarted = () =>
    useGameStore((s:TimestampsSlice) => !!s.planningEndTime);

export const useCrunchTimeStartTime = () =>
    useGameStore((s:TimestampsSlice) => s.crunchTimeStartTime);
